<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive code="decla1" v-model="sasArmCanada.decla1" :live="liveSasArmCanada(9119)" />
      <CaseACocherLive code="decla2" v-model="sasArmCanada.decla2" :live="liveSasArmCanada(9120)" />
      <CaseACocherLive code="decla3" v-model="sasArmCanada.decla3" :live="liveSasArmCanada(9121)" />
      <CaseACocherLive code="decla4" v-model="sasArmCanada.decla4" :live="liveSasArmCanada(9122)" />
      <CaseACocherLive code="decla5" v-model="sasArmCanada.decla5" :live="liveSasArmCanada(9123)" />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasArmCanada() {
      return this.sas.sasArmCanada
    }
  },
  methods: {
    liveSasArmCanada(cle) {
      return { endpoint: "sas-reconnaissance-arm-canada", cle: cle, fileId: this.sasArmCanada.id }
    }
  }
}
</script>

<style>
</style>